import { waitForTmaInitData } from '@common/services/tmaInitDataService';
import { fetcher } from '@common/utils/fetcher';

import { type Account } from './AccountService';
import { type DetailResponse } from './types';
import {
  type Referrals,
  type User,
  type VerificationStatus,
} from './UsersService';

export interface SwipeStatus {
  limit: number | null;
  remaining: number | null;
  reset_time: string | null;
}

export type PostAuthResponse = {
  registered: boolean;
  user: User;
  swipe_status: SwipeStatus;
  verification_status: VerificationStatus;
  referrals: Referrals;
  account?: Account | null;
};

export type StartTmaFeatures = {
  matchmaker: boolean;
  superlike: boolean;
};

export type PostStartTmaResponse = {
  appInstance?: {
    id?: string;
  };
  features?: StartTmaFeatures;
};

export type PostRegisterTmaDatingParams = {
  app_instance_id: string;
  username: string;
  dob: string;
  about: string;
  goal: string;
  city: string;
  looking_for: 0 | 1;
  sex: 0 | 1;
  photos: string[];
  is_matchmaker?: boolean;
};

export type PostRegisterTmaMatchmakerParams = {
  mode: 'matchmaker';
  app_instance_id: string;
  username: string;
  dob: string;
  city: string;
  looking_for?: 0 | 1;
  sex: 0 | 1;
  photos: [string];
};

export type PostRegisterTmaParams =
  | PostRegisterTmaDatingParams
  | PostRegisterTmaMatchmakerParams;

export type PostRegisterTmaResponse = DetailResponse | void;

export type PostVerifyParams = {
  photo_url: string;
  notes?: string;
};

export type PostVerifyResponse = null;

export const postAuth = () => {
  return fetcher<PostAuthResponse>({
    url: '/auth',
    method: 'POST',
  });
};

export const postRegisterTma = async (data: PostRegisterTmaParams) => {
  const initData = await waitForTmaInitData();

  if (!initData) {
    throw new Error('Telegram initData is not available');
  }

  return fetcher<PostRegisterTmaResponse>({
    url: '/register/tma',
    method: 'POST',
    data: {
      ...data,
      initData,
    },
    auth: null,
  });
};

export const postVerify = (data: PostVerifyParams) => {
  return fetcher<PostVerifyResponse>({
    url: '/verify',
    method: 'POST',
    data,
  });
};
